export const config = {
  cognito: {
    userPoolId: 'eu-west-3_abTBNREBJ',
    userPoolClientId: '4j9q6in6cpcsmroimb30b54d5s', // Public client (no secret)
    region: 'eu-west-3',
    domain: 'https://thor-auth.auth.eu-west-3.amazoncognito.com',
    // Détecte automatiquement l'URL selon l'environnement
    redirectUri: window.location.origin.includes('localhost')
      ? 'http://localhost:3000'
      : window.location.origin,
    logoutUri: window.location.origin.includes('localhost')
      ? 'http://localhost:3000'
      : window.location.origin
  },
  api: {
    // API unifiée Thor pour TITRE + abonnements
    endpoint: process.env.REACT_APP_API_ENDPOINT || 'https://n3gnin38qf.execute-api.eu-west-3.amazonaws.com/prod',
    // API spécifique pour génération de titres (ancienne API demo-thor)
    titreEndpoint: 'https://rnvxddeckj.execute-api.eu-west-3.amazonaws.com/prod'
  },
  app: {
    title: 'ThorPodcast - Générateur de Titre & Résumé IA',
    version: '2.0.0',
    supportedFormats: ['txt', 'pdf', 'docx', 'rtf', 'csv', 'json'],
    maxFileSize: 52428800, // 50MB
    userGroups: ['titre']
  }
};